import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../redux/hooks';
import { getUser } from '../../../../redux/actions/user-actions';
import { refreshToken } from '../../../../redux/login/login-actions';
import useQueryParams from '../../../../hooks/UseQueryParams';
import { trackPurchase } from '../../../../utils/google/google-analytics';
import { userNavigateWithClassCode } from '../../../../utils/user-route-getter';
import { teacherRoutes } from '../../../../constants/routes';
import { push } from 'connected-react-router';
import { premiumPlusBreakDownData } from '../premium-plans/premium-plus-breakdown-data';
import { userTypesDashboardRoute } from '../../../../constants/users';
import mixpanel from '../../../../utils/mixpanel';

const MembershipPurchaseSuccess = () => {
  const { token } = useAppSelector(state => state.login);
  const { userType, newRegistrationFlow, premium } = useAppSelector(
    state => state.userData
  );
  const dispatch = useDispatch();
  const params = useQueryParams();

  React.useEffect(() => {
    console.log('membership success', premium);
    if (params) {
      try {
        const { price, product_name, discount, memberships, currency } = params;
        let currentPlanType = 'None';
        if (memberships) {
          currentPlanType = `Premium ${memberships}`;
        }
        const transactionId = new Date().getTime();
        const membershipsPrice =
          parseInt(memberships) <= 40
            ? premiumPlusBreakDownData.find(
                item => item.memberships === parseInt(memberships)
              )?.totalPlanCost
            : parseInt(memberships) * 5;

        trackPurchase(
          transactionId,
          price,
          product_name,
          discount,
          memberships,
          membershipsPrice,
          currency
        );
      } catch (err) {
        console.log(err);
      }
    }
    dispatch(refreshToken());
    dispatch(getUser(token, false));

    if (
      newRegistrationFlow &&
      (newRegistrationFlow === 'A' ||
        newRegistrationFlow === 'B' ||
        newRegistrationFlow === 'C') &&
      premium.isPremium
    ) {
      dispatch(push(userTypesDashboardRoute[userType]));
    } else {
      dispatch(
        push(
          userNavigateWithClassCode(
            teacherRoutes.teacherPremiumPlanClass + `?reDirect=1`
          )
        )
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [premium.isPremium]);
  return <span></span>;
};

export default MembershipPurchaseSuccess;
